// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3u1hd","list":"PatternAutocomplete_list__l1oxb"};